"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var react_spring_1 = require("react-spring");
var styles_1 = require("./styles");
var components_1 = require("./components");
function Dialog(_a) {
    var show = _a.show, children = _a.children, className = _a.className, style = _a.style;
    var spring = react_spring_1.useTransition(show, null, {
        delay: 2,
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
    });
    return react_dom_1.createPortal(react_1.default.createElement(react_1.default.Fragment, null, spring.map(function (_a) {
        var item = _a.item, key = _a.key, props = _a.props;
        return item ? (react_1.default.createElement(styles_1.Backdrop, { key: key, style: props, "aria-modal": "true", role: "dialog" },
            react_1.default.createElement(styles_1.Container, { key: key, className: className, style: __assign(__assign({}, props), style) }, children))) : null;
    })), document.body);
}
exports.default = Dialog;
Dialog.Header = components_1.DialogHeader;
Dialog.Close = components_1.DialogClose;
Dialog.Title = components_1.DialogTitle;
Dialog.Body = components_1.DialogBody;
Dialog.Footer = components_1.DialogFooter;
//# sourceMappingURL=index.js.map